import React from 'react';
import { Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { thin } from '@fortawesome/fontawesome-svg-core/import.macro';
import ModelFeatureValue from './ModelFeatureValue';

const ModelFeaturesList = ({
    modelFeatures,
    onShowDetails,
    showConversions = false,
    showAdditionalInfo = false,
    nameTag = 'span',
    valueTag = 'span',
}) => {
    const hasFeatures = Boolean(modelFeatures && modelFeatures.length);
    //il drawer porta anche birthdate, età e custom fields: dove le conversioni non ci sono
    //resta comunque l'unico modo per arrivarci nei layout non estesi
    const showDetailsButton = Boolean(onShowDetails) && (showConversions || showAdditionalInfo);

    if (!hasFeatures && !showDetailsButton) {
        return null;
    }

    const NameTag = nameTag;
    const ValueTag = valueTag;

    return (
        <div className="model-features">
            {hasFeatures && modelFeatures.map((feature) => (
                <div className="model-feature" key={feature.id || feature.displayName}>
                    <NameTag className="model-feature-name">{feature.displayName}</NameTag>
                    <ValueTag className="model-feature-value">
                        <ModelFeatureValue feature={feature}>
                            {feature.formattedValues.join(' • ')}
                        </ModelFeatureValue>
                    </ValueTag>
                </div>
            ))}
            {showDetailsButton &&
                <div className="model-feature-more" onClick={onShowDetails}>
                    <Tooltip title={showConversions ? 'Show international measurement conversions' : 'Show model details'}>
                        <FontAwesomeIcon icon={thin('globe')} />
                    </Tooltip>
                </div>
            }
        </div>
    );
};

export default ModelFeaturesList;
